var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"universal-button",class:( _obj = {}, _obj[_vm.size] = true, _obj[_vm.variant] = true, _obj.block = _vm.block, _obj.glow = _vm.glow, _obj ),on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('span',{staticClass:"icon"},[_vm._t("icon")],2),_vm._t("default"),(_vm.caret)?_c('CaretIcon',{staticClass:"caret"}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }